import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import HowItWorks from "@/components/HowItWorks";
import Offers from "@/components/Offers";
import WhyUs from "@/components/WhyUs";
import TelegramCta from "@/components/TelegramCta";
import Stats from "@/components/Stats";
import Faq from "@/components/Faq";
import Footer from "@/components/Footer";
import StickyCta from "@/components/StickyCta";
import CookieBanner from "@/components/CookieBanner";
import LegalPage from "@/pages/LegalPage";
import "@/App.css";

function ScrollManager() {
    const { pathname } = useLocation();
    useEffect(() => {
        if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
        else window.scrollTo(0, 0);
    }, [pathname]);
    return null;
}

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }
    static getDerivedStateFromError(error) {
        return { error };
    }
    render() {
        if (this.state.error) {
            return (
                <div className="flex min-h-screen items-center justify-center bg-paper p-8 text-center">
                    <p className="text-ink/70">Qualcosa è andato storto. Ricarica la pagina.</p>
                </div>
            );
        }
        return this.props.children;
    }
}

const Home = () => (
    <main>
        <Hero />
        <Marquee />
        <HowItWorks />
        <Offers />
        <WhyUs />
        <TelegramCta />
        <Stats />
        <Faq />
    </main>
);

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
        window.__lenis = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <ErrorBoundary>
            <BrowserRouter>
                <ScrollManager />
                <Navbar />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/privacy" element={<LegalPage pageKey="privacy" />} />
                    <Route path="/cookie-policy" element={<LegalPage pageKey="cookie" />} />
                    <Route path="/termini" element={<LegalPage pageKey="termini" />} />
                    <Route path="/disclaimer" element={<LegalPage pageKey="disclaimer" />} />
                    <Route path="/affiliazione" element={<LegalPage pageKey="affiliazione" />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
                <Footer />
                <StickyCta />
                <CookieBanner />
            </BrowserRouter>
        </ErrorBoundary>
    );
}

export default App;
